export enum MenuPointUrl {
	DASHBOARD = '/dashboard',
	SETTINGS = '/settings',
	FLEET = '/fleet',
	RELEASE_NOTES = '/release-notes',
	MAAS = '/maas',
}
